import { ChangeDetectorRef, Compiler, Component, Injector, NgModuleFactory, OnInit, inject, OnDestroy } from '@angular/core';
import { notificationConfig } from './notification-config';
import { select, Store } from '@ngrx/store';
import { getSnackbar, SnackbarExibirNotificacao } from '../app/store';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar} from '@angular/material/snack-bar';
import * as fromStore from '../app/store';
import { Subject } from 'rxjs';
import { DateTime } from 'luxon';
import CryptoJS from 'crypto-js';

@Component({
    selector: 'notification',
        template: ''
})
export class NotificationComponent implements OnInit, OnDestroy {
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _snackbar = inject(MatSnackBar);
    private _store = inject<Store<fromStore.State>>(Store);
    private _compiler = inject(Compiler);
    private _injector = inject(Injector);

    modules: any[] = [];
    private _unsubscribeAll: Subject<any>;



    /**
     * @param _changeDetectorRef
     * @param _snackbar
     * @param _store
     * @param _compiler
     * @param _injector
     */
    constructor() {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.loadModules();

        this._store
            .pipe(
                select(getSnackbar),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe((snackbar) => {
                if (snackbar.exibir) {
                    this.openComponent(snackbar.notificacao);
                    this._store.dispatch(new SnackbarExibirNotificacao({exibir: false, notificacao: null}));
                }
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    /**
     * Open
     *
     * @param notification
     */
    private openComponent(notification) {
        const modules = this.modules.sort((a, b) => (a.order > b.order) ? 1 : -1);
        const selector = modules.find(item => item.module.instance.supports(notification));

        if(!this.canDispatch(notification)) {
            return;
        }

        selector.config.data = notification;
        this._snackbar.openFromComponent(
            selector.module.instance.resolveComponentFactory().componentType,
            selector.config
        );
    }

    /**
     * Load
     */
    private loadModules() {
        notificationConfig.forEach((notification) => {
            this.instanceModule(notification.module).then((moduleNotification) => {
                this.modules.push({
                    module: moduleNotification,
                    config: notification.config,
                    order: notification.order
                });
            });
        });
    }

    /**
     * Instance
     *
     * @param i
     */
    private instanceModule(i: any): Promise<any> {
        return i()
            .then((lazyModule) => {
                if (lazyModule instanceof NgModuleFactory) {
                    return lazyModule.create(this._injector);
                } else {
                    return this._compiler.compileModuleAsync(lazyModule).then(compiledModule => compiledModule.create(this._injector));
                }
            });
    }

    private canDispatch(notification): boolean {
        if(notification?.modalidadeNotificacao?.valor === 'SISTEMA' && notification?.grupo) {
            const sessionStorageKey = `lastNotification`;

            const key = CryptoJS.SHA256(`${notification.tipoNotificacao?.nome}-${notification.grupo}-${notification.contexto}`).toString(CryptoJS.enc.Hex);
            const interval = DateTime.now().minus({ minutes: 5 });
            const lastNotification = JSON.parse(sessionStorage.getItem(sessionStorageKey) ?? '{}');
            
            Object.keys(lastNotification).forEach(k => {
                if(DateTime.fromISO(lastNotification[k]) < interval) {
                    delete lastNotification[k];
                }
            });
            
            const dispatch = lastNotification[key] ? false : true;
            if(dispatch){
                lastNotification[key] = DateTime.now().toISO();
            }
            sessionStorage.setItem(sessionStorageKey, JSON.stringify(lastNotification));
            return dispatch;
        }

        return true;
    }
}
